module.exports = __webpack_public_path__ + "img/phone.ac45cdf0.svg";